import apiRequest from '@/js/helpers/apiRequest';
import { buildErrorCollection } from '@/js/utils/processingOpenApi';
import { ERROR_CALL_ORDER } from '@/js/utils/constants/constUser';

/**
 * Новый эндпоинт - Получает информацию о номере
 * @param {object} payload
 * @param {string} [payload.phone]
 * @return {Promise<number>}
 */
export default function getPhoneInfo(payload) {
  return new Promise((resolve, reject) => {
    if (!payload.phone) {
      return reject(ERROR_CALL_ORDER.notStringPhone);
    }
    if (typeof payload.phone !== 'string') {
      return reject(ERROR_CALL_ORDER.emptyPhone);
    }
    return apiRequest.get(`/phones/?phone=${payload.phone}`)
      .then((dataRes) => {
        if (dataRes.success) {
          const tokenExpiredAt = dataRes?.data?.data[0]?.attributes?.tokenExpiredAt;
          if (tokenExpiredAt) {
            return resolve(tokenExpiredAt);
          }
          return resolve(null);
        }

        throw new Error();
      })
      .catch((e) => {
        if (e.data) {
          const errors = buildErrorCollection(e.data);
          const [firstError] = errors;
          return reject(firstError);
        }
        return reject(e);
      });
  });
}
